import { render, staticRenderFns } from "./lunchTables.vue?vue&type=template&id=c5ee073a&scoped=true"
import script from "./lunchTables.vue?vue&type=script&lang=js"
export * from "./lunchTables.vue?vue&type=script&lang=js"
import style0 from "./lunchTables.vue?vue&type=style&index=0&id=c5ee073a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ee073a",
  null
  
)

export default component.exports